import { shuffle, uniqBy } from 'lodash-es';

import { GolfClubPromotion, MappedGolfCourseType } from '../services/apis/golfCourses/types';

export const sortPromotedGolfCourses = (
  golfCourses: MappedGolfCourseType[]
): MappedGolfCourseType[] => {
  const promotedGolfCourses = shuffle(
    golfCourses.filter(golfCourse => golfCourse.promotion === GolfClubPromotion.Promoted)
  );

  const recommendedGolfCourses = shuffle(
    golfCourses.filter(golfCourse => golfCourse.promotion === GolfClubPromotion.Recommended)
  );

  return uniqBy(
    [...promotedGolfCourses, ...recommendedGolfCourses, ...golfCourses],
    golfCourse => golfCourse.id
  );
};
